import React, { useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import { Column, Row } from 'components/simpleFlexbox';
import SLUGS from 'resources/slugs';
import useSignUp from 'hooks/auth/useSignUp';
import SignupBanner from 'assets/app-login-bg.gif';
import DataroFullLogo from 'assets/dataro-full-logo.png';
import LoadingComponent from 'components/loading';
import CreateAccountComponentDefault from './CreateAccountComponent';
import CreateAccountComponentFiFree from './CreateAccountComponentFiFree';
import AlmostThereComponent from './AlmostThereComponent';
import useExternalScripts from 'hooks/useExternalScripts';
import trackingPixel1 from 'resources/jsScripts/trackingPixel/trackingPixel1';
import trackingPixel2 from 'resources/jsScripts/trackingPixel/trackingPixel2';
import './signup.css';

function SignUpComponent() {
    const { type: signup_pageProp, source } = useParams();
    const { error, errorResend, loading, resendEmail, signUp } = useSignUp();
    const [userData, setUserData] = useState();
    useExternalScripts({
        id: 'script_tracking_pixel',
        content: trackingPixel1,
        include: process.env.REACT_APP_SCRIPT_TRACKING_PIXEL
    });
    useExternalScripts({
        id: 'script_tracking_pixel_2',
        content: trackingPixel2,
        include: process.env.REACT_APP_SCRIPT_TRACKING_PIXEL
    });
    const isSignupFreeRoute = useRouteMatch(SLUGS.signupFree);
    const signup_page = signup_pageProp || (isSignupFreeRoute ? 'fi_free' : 'demo');

    let CreateAccountComponent;
    switch (signup_page) {
        case 'fi_free':
            CreateAccountComponent = CreateAccountComponentFiFree;
            break;

        default:
            CreateAccountComponent = CreateAccountComponentDefault;
            break;
    }

    async function onSubmit({ email, password, firstName, lastName, phone = ' ' }) {
        try {
            await signUp({
                email,
                password,
                firstName,
                lastName,
                phone,
                source,
                signup_page
            });
            setUserData({ email });
        } catch (e) {
            console.log(e.message);
        }
    }

    return (
        <Row>
            <LoadingComponent loading={loading} />
            <Column horizontal='center' vertical='center' className='signup-banner-container'>
                <Column className='signup-banner-images' horizontal='center'>
                    <div className='signup-dataro-logo'>
                        <img src={DataroFullLogo} alt='dataro full logo' />
                    </div>
                    <img src={SignupBanner} alt='signup banner' />
                </Column>
            </Column>
            <Column flexGrow={1} className='signup-container' vertical='center'>
                <Column className='signup-inner-container'>
                    {!userData ? (
                        <CreateAccountComponent onSubmit={onSubmit} errorMessage={error} />
                    ) : (
                        <AlmostThereComponent
                            email={userData.email}
                            errorMessage={errorResend}
                            resendEmail={resendEmail}
                        />
                    )}
                </Column>
            </Column>
        </Row>
    );
}

export default SignUpComponent;
